import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a40491f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import TablaClasificacionElo from "@/components/Elo/TablaClasificacionElo.vue";
import TablaClasificacionEloEquipos from "@/components/Elo/TablaClasificacionEloEquipos.vue";
import { UsuarioEloTablaClasificacion } from "@/interfaces/Elo";
import { FaccionDTO } from "@/interfaces/Faccion";
import { getFacciones } from "@/services/FaccionesService";
import { onMounted, ref } from "vue";
import { useAuth } from "@/composables/useAuth";
import { useRouter } from "vue-router";
import LoadingGandalf from "@/components/Commons/LoadingGandalf.vue";
import { useEloStore } from "@/store/elo";


export default /*#__PURE__*/_defineComponent({
  __name: 'EloView',
  setup(__props) {

const eloStore = useEloStore();

const tab = ref<string>("Individual");

const { getidUsuario } = useAuth();
const idUsuarioLogger = ref<number>(parseInt(getidUsuario.value));
const error = ref<string | null>(null);
const router = useRouter();
const idUsuario = ref<number>();
const isLoading = ref<boolean>(true);
const eloClasificacion = ref<UsuarioEloTablaClasificacion[]>([]);
const facciones = ref<FaccionDTO[]>([]);

onMounted(async () => {
  isLoading.value = true;
  try {
    // Obtener el usuario
    const id = idUsuarioLogger.value;
    if (!id) {
      error.value = "No se pudo obtener el usuario. Por favor, inicie sesión.";
      router.push({ name: "error" });
      return;
    }
    idUsuario.value = id;

    // Hacer peticiones en paralelo
    const [clasificacionEloData, faccionesResponse] = await Promise.all([
      eloStore.fetchClasificacionElo(),
      getFacciones(),
    ]);

    // Procesar la clasificación ELO
    eloClasificacion.value = clasificacionEloData.sort(
      (a: { elo: number }, b: { elo: number }) => b.elo - a.elo
    );
    eloClasificacion.value = eloClasificacion.value.map((item, index) => ({
      ...item,
      clasificacion: index + 1,
    }));

    // Procesar las facciones
    facciones.value = faccionesResponse.data;
  } catch (err) {
    console.error("Error al obtener datos del usuario:", error.value);
  } finally {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "elo" }, {
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(LoadingGandalf)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_v_tabs, {
              modelValue: tab.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
              color: "primary",
              grow: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tab, { value: "Individual" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Individual ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tab, { value: "Equipos" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Equipos ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_tabs_window, {
              modelValue: tab.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event))
            }, {
              default: _withCtx(() => [
                (tab.value === 'Individual')
                  ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                      key: 0,
                      value: "Individual"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(TablaClasificacionElo, {
                          class: "separated",
                          items: eloClasificacion.value
                        }, null, 8, ["items"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (tab.value === 'Equipos')
                  ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                      key: 1,
                      value: "Equipos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(TablaClasificacionEloEquipos, {
                          class: "separated",
                          items: eloClasificacion.value,
                          facciones: facciones.value
                        }, null, 8, ["items", "facciones"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
    ]),
    _: 1
  }))
}
}

})